//package/index.js
import PMobileInput from "@/package-product/p-mobile-input/index.vue";

// 所有组件
const components = [
    PMobileInput
];

// install 方法
const install = function (Vue) {
    components.forEach((com) => {
        Vue.component(com.name, com);
    });
};

// 支持按需引入
export { PMobileInput };

// 支持全局引入
export default install;